//import Button from "../Button";
import Title from "../Title";
import Subtitle from "../Subtitle";
import Text from "../Text";
import Image from "../Image";

import "./index.css";

interface CharacterProps {
  character: CharacterType;
  type: TemplateType;
}
const Character = (props: CharacterProps) => {
  const {
    title,
    subtitle,
    items,
    image,
    gif,
    next,
    listMarginTop = "45px",
    gifStyle = {},
  } = props.character;
  const { type } = props;

  const handleOnClick = () => {
    if (next.onClick) next.onClick();
  };

  return (
    <div className="base-character" onClick={handleOnClick}>
      <div style={{ position: "relative", zIndex: 2 }}>
        <Title style={styles.title} type={type} text={title} />
        <Subtitle style={styles.subtitle} type={type} text={subtitle} />
        <div style={{ ...styles.enabling, marginTop: listMarginTop }}>
          ENABLING
        </div>
        {items.map((item: string, index: number) => (
          <div key={index} style={{ display: "flex", marginBottom: "24px" }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.70711 14.2929L19 5L20.4142 6.41421L9.70711 17.1213L4 11.4142L5.41421 10L9.70711 14.2929Z"
                fill="#007633"
              />
            </svg>
            <Text style={styles.item} text={item} />
          </div>
        ))}
      </div>
      {image && <Image style={styles.image} imagePath={image} />}
      {gif && (
        <div style={styles.gifContainer}>
          <Image styleImage={styles.gif} style={gifStyle} imagePath={gif} />
        </div>
      )}
    </div>
  );
};

const styles = {
  title: {
    color: "#111",
    fontSize: "68px",
    fontWeight: "350",
    lineHeight: "100%",
  },
  subtitle: {
    color: "#111",
    fontFamily: "Myriad Pro",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "100%",
    opacity: "0.75",
    marginTop: "11px",
  },
  enabling: {
    color: "#111",
    fontFamily: "Myriad Pro",
    fontSize: "18px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "100%",
    opacity: "0.75",
    marginBottom: "12px",
  },
  item: {
    color: "#111",
    fontFamily: "Myriad Pro",
    fontSize: "24px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "100%",
    opacity: "0.75",
    paddingLeft: "10px",
  },
  image: {
    position: "absolute" as "absolute",
    right: 0,
    bottom: "-4px",
    zIndex: 0,
  },
  gif: {
    position: "absolute" as "absolute",
    right: "-89px",
    width: "349px",
    height: "auto",
    bottom: "-4px",
    zIndex: 0,
  },
  gifContainer: {
    position: "absolute" as "absolute",
    right: 0,
    bottom: 0,
    zIndex: 0,
  },
};

export default Character;
